/* eslint-disable */
import { Circle, Heading, HStack, Image } from "@chakra-ui/react";
import Box from "@material-ui/core/Box";
import React, { Component } from "react";
import { withTranslation } from "react-i18next";
import { Row } from "reactstrap";
import { connect } from "react-redux";

import {
  getAllRiskProfiles,
  update_RiskProfiles,
  add_RiskProfiles,
  delete_RiskProfiles,
} from "../../utils/store/actions/risk.actions";
import SaveIcon from "@material-ui/icons/Save";
import DeleteIcon from "@material-ui/icons/Delete";
import AddCircleIcon from "@material-ui/icons/AddCircle";

import {
  createStyles,
  Paper,
  Table,
  TableBody,
  TableContainer,
  TableHead,
  TableCell,
  TableRow,
  Theme,
  withStyles,
  Button,
  Input,
} from "@material-ui/core";
import EditIcon from "@material-ui/icons/Edit";
const styles = (theme: Theme) =>
  createStyles({
    paper: {
      maxWidth: "90%",
      margin: "auto",
      marginTop: "5%",
      backgroundColor: "transparent",
      boxShadow: "none",
    },
    contentWrapper: {
      margin: "40px 16px",
    },
    cell: {},
    input: {
      border: "2px solid #D8D8D8",
      borderRadius: "5px",
      "&$focused": {
        width: "40%",
        borderColor: "red",
        boxShadow: "0 0 0 0.2rem rgba(0,123,255,.25)",
      },
    },
  });
class RiskProfil extends Component<any, any> {
  constructor(props: any) {
    super(props);
    this.state = {
      name: "Prudent",
      miminumScore: 0,
      maximumScore: 0,
    };
  }
  componentDidMount() {
    this.props.getAllRiskProfiles();
  }
  render() {
    const { t, classes } = this.props;
    return (
      <div>
        <Box
          style={{
            margin: "50px",
            display: "flex",
            alignItems: "top",
          }}
        >
          <HStack cursor="pointer">
            <Heading
              fontSize="18px"
              fontFamily="Inter, sans-serif"
              color="brand.bf3"
            >
              {t("RISK_PROFILE_CONFIGRATION")}
            </Heading>
            <Image src="/icon/check-circle.svg" />
          </HStack>
        </Box>
        <Box
          style={{
            display: "flex",
            margin: "50px",
            flexDirection: "column",
          }}
        >
          <span>{t("SCORING_FOR_EACH_PROFILE")}</span>
          <span>{t("CONFIGURATION_OF_RISK_PROFILE_VALUES")}</span>
        </Box>
        <Paper className={classes.paper}>
          <div className={classes.contentWrapper}>
            <TableContainer component={Paper}>
              <Table stickyHeader aria-label="simple table">
                <TableHead>
                  <TableRow>
                    <TableCell align="center">{t("PROFILE")}</TableCell>
                    <TableCell align="center">Score Minimum</TableCell>
                    <TableCell align="center"></TableCell>
                    <TableCell align="center">Score Maximum</TableCell>
                    <TableCell align="center">{t("EDIT")}</TableCell>
                    <TableCell align="center"></TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {this.props.Risk?.risk_profile_list?.content.map(
                    (config: any) => (
                      <TableRow>
                        <TableCell align="center">
                          {this.state[`edit_${config.id}`] ? (
                            <Input
                              value={this.state[config.id].name}
                              onChange={(e) =>
                                this.setState({
                                  [config.id]: {
                                    ...this.state[config.id],
                                    name: e.target.value,
                                  },
                                })
                              }
                            />
                          ) : (
                            config.name
                          )}
                        </TableCell>
                        <TableCell align="center">
                          {this.state[`edit_${config.id}`] ? (
                            <Input
                              value={this.state[config.id].minimumScore}
                              onChange={(e) =>
                                this.setState({
                                  [config.id]: {
                                    ...this.state[config.id],
                                    minimumScore: e.target.value,
                                  },
                                })
                              }
                            />
                          ) : (
                            config.minimumScore
                          )}
                        </TableCell>
                        <TableCell align="center">{t("TO_DATE")}</TableCell>
                        <TableCell align="center">
                          {this.state[`edit_${config.id}`] ? (
                            <Input
                              value={this.state[config.id].maximumScore}
                              onChange={(e) =>
                                this.setState({
                                  [config.id]: {
                                    ...this.state[config.id],
                                    maximumScore: e.target.value,
                                  },
                                })
                              }
                            />
                          ) : (
                            config.maximumScore
                          )}
                        </TableCell>
                        <TableCell align="center">
                          {this.state[`edit_${config.id}`] ? (
                            <Button
                              onClick={() => {
                                this.props
                                  .update_RiskProfiles(
                                    this.state[config.id],
                                    config.id
                                  )
                                  .then(() => this.props.getAllRiskProfiles());
                                this.setState({
                                  [`edit_${config.id}`]: !this.state[
                                    `edit_${config.id}`
                                  ],
                                });
                              }}
                            >
                              <SaveIcon />
                            </Button>
                          ) : (
                            <Button
                              onClick={() =>
                                this.setState({
                                  [`edit_${config.id}`]: !this.state[
                                    `edit_${config.id}`
                                  ],
                                  [config.id]: {
                                    ...this.state[config.id],
                                    name: config.name,
                                    maximumScore: config.maximumScore,
                                    minimumScore: config.minimumScore,
                                  },
                                })
                              }
                            >
                              <EditIcon />
                            </Button>
                          )}
                        </TableCell>
                        <TableCell align="center">
                          {this.state[`edit_${config.id}`] && (
                            <Button
                              onClick={() =>
                                this.props
                                  .delete_RiskProfiles(config.id)
                                  .then(() => this.props.getAllRiskProfiles())
                              }
                            >
                              <DeleteIcon />
                            </Button>
                          )}
                        </TableCell>
                      </TableRow>
                    )
                  )}
                  {this.state.add_criteria && (
                    <TableRow>
                      <TableCell align="center">
                        <Input
                          value={this.state.criteria.name || ""}
                          onChange={(e) =>
                            this.setState({
                              criteria: {
                                ...this.state.criteria,
                                name: e.target.value,
                              },
                            })
                          }
                          type="text"
                          placeholder={t("NAME")}
                        />
                      </TableCell>
                      <TableCell align="center">
                        <Input
                          value={this.state.criteria.minimumScore || ""}
                          onChange={(e) =>
                            this.setState({
                              criteria: {
                                ...this.state.criteria,
                                minimumScore: e.target.value,
                              },
                            })
                          }
                          type="number"
                          placeholder="minimum score"
                        />
                      </TableCell>
                      <TableCell align="center">{t("TO_DATE")}</TableCell>
                      <TableCell align="center">
                        <Input
                          value={this.state.criteria.maximumScore || ""}
                          onChange={(e) =>
                            this.setState({
                              criteria: {
                                ...this.state.criteria,
                                maximumScore: e.target.value,
                              },
                            })
                          }
                          type="number"
                          placeholder="maximum score"
                        />
                      </TableCell>
                      <TableCell align="center"></TableCell>
                      <TableCell align="center">
                        <Button
                          onClick={(e) => {
                            e.preventDefault();
                            this.setState({ add_criteria: false });
                            this.props
                              .add_RiskProfiles(this.state.criteria)
                              .then(() => this.props.getAllRiskProfiles());
                          }}
                        >
                          {t("ADD")}
                        </Button>
                      </TableCell>
                    </TableRow>
                  )}
                </TableBody>
              </Table>
            </TableContainer>
            <div>
              <Button
                onClick={(e) =>
                  this.setState({
                    add_criteria: true,
                    criteria: {
                      ...this.state.criteria,
                    },
                  })
                }
              >
                <AddCircleIcon />
              </Button>
            </div>
          </div>
        </Paper>
      </div>
    );
  }
}
const mapStateToProps = (state: any) => ({
  ...state,
});

const mapDispatchToProps = {
  getAllRiskProfiles,
  update_RiskProfiles,
  add_RiskProfiles,
  delete_RiskProfiles,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withTranslation()(withStyles(styles)(RiskProfil)));
